import { useEffect } from 'react';
import { MonthCalendar } from './Calendars';
import { DateTime, Interval } from 'luxon';
import { useDispatch } from 'react-redux';
import { setShowPicker } from '../features/settingSlice';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import '../style/_IntervalPicker.scss';
import CloseIcon from '@mui/icons-material/Close';

function IntervalPicker({ onSelect, monthsInterval }) {
  const dispatch = useDispatch();
  const currDate = DateTime.local();

  useEffect(() => {
    var body = document.body;
    body.classList.add("stop");
    return () => {
      var body = document.body;
      body.classList.remove("stop");
    };
  });

  return (
    <div className='IntervalPicker'>
        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
          <div style={{border: '1px solid #fff', margin: '15px', borderRadius: '50%', padding: '3px'}} onClick={() => dispatch(setShowPicker(false))}>
            <CloseIcon />
          </div>
        </div>
        <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
          <p className='instructions' style={{ color: 'white' }}>Seleziona il periodo o il singolo mese</p>
          <CommonIntervalsPicker onChange={onSelect} />
          <div className='month-calendar-wrapper'>
            <MonthCalendar
              defaultYear={currDate.year}
              interval={monthsInterval}
              onChange={(d) => onSelect({
                label: d.toFormat('MMMM y'),
                interval: Interval.fromDateTimes(d.startOf('month'), DateTime.min(d.endOf('month'), monthsInterval.end))
              })} />
          </div>
        </div>
    </div>
  );
}

function CommonIntervalsPicker({ onChange }) {
  const onLastNumMonths = (n) => onChange({
    label: `Ultimi ${n} Mesi`,
    interval: Interval.fromDateTimes(
      DateTime.local().minus({ months: n - 1 }).startOf('month'),
      DateTime.local().endOf('month')
      ),
  });
  
  return (
    <div className='common-intervals-grid'>
      <button onClick={() => onLastNumMonths(3)}>Ultimi 3 Mesi</button>
      <div className='intervals-divider' />
      <button onClick={() => onLastNumMonths(6)}>Ultimi 6 Mesi</button>

      <div className='intervals-divider intervals-row-divider' />

      <button onClick={() => onLastNumMonths(12)}>Ultimi 12 Mesi</button>
      <div className='intervals-divider' />
      <button onClick={() => onChange({
        label: 'Tutti',
        interval: Interval.fromDateTimes(DateTime.local(2000), DateTime.local()),
      })}>Tutti</button>
    </div>
  );
}

export default IntervalPicker;
